import { SiteMapGlobalResponseType } from '@propertypal/shared/src/types/siteMap';
import platform from '@propertypal/shared/src/utils/platform';
import Link from 'next/link';
import React, { FunctionComponent } from 'react';
import { useTheme } from 'styled-components';
import PageWrapper from '../layout/PageWrapper';
import { Heading, SubHeading, Text } from '../typography';
import { Letter, LetterList, List, ListItem, Section } from './SiteMapGlobal.style';

interface SiteMapData {
  data: SiteMapGlobalResponseType;
}

const SiteMapGlobal: FunctionComponent<SiteMapData> = (props) => {
  const theme = useTheme();
  const { countries, agentAtoZ, townAtoZ } = props.data;

  return (
    <>
      <Section>
        <PageWrapper>
          <Heading fontSize={32} fontWeight="300">
            {platform.domain.toUpperCase()} SITE MAP
          </Heading>
        </PageWrapper>
      </Section>

      {countries.map((country) => {
        return (
          <Section key={country.name}>
            <PageWrapper>
              <div key={country.name}>
                <SubHeading
                  fontSize={35}
                  fontWeight="300"
                  color={theme.textDark}
                  style={{ marginTop: 40, marginBottom: 40 }}
                >
                  {country.name.toUpperCase()}
                </SubHeading>
                {country.categories.map((category) => {
                  return (
                    <React.Fragment key={category.name}>
                      <SubHeading fontSize={20} fontWeight="300">
                        {category.name.toUpperCase()}
                      </SubHeading>
                      <List>
                        {category.links.map((link) => {
                          return (
                            <ListItem key={link.label}>
                              <Link href={link.url} prefetch={false}>
                                <Text fontSize={14}>{link.label}</Text>
                              </Link>
                            </ListItem>
                          );
                        })}
                      </List>
                    </React.Fragment>
                  );
                })}
              </div>
            </PageWrapper>
          </Section>
        );
      })}

      <Section>
        <PageWrapper>
          <SubHeading fontSize={21} fontWeight="300" style={{ marginTop: 40, marginBottom: 40 }}>
            ESTATE AGENTS
          </SubHeading>
          <LetterList>
            {Object.entries(agentAtoZ).map((item) => {
              const [key, value] = item;
              return (
                <Letter key={key} isActive={value}>
                  {value ? (
                    <Link href={`/site-map-agents/${key}`} prefetch={false}>
                      <Text fontSize={13}>{key}</Text>
                    </Link>
                  ) : (
                    <Text fontSize={13}>{key}</Text>
                  )}
                </Letter>
              );
            })}
          </LetterList>
        </PageWrapper>
      </Section>

      <Section>
        <PageWrapper>
          <SubHeading fontSize={21} fontWeight="300" style={{ marginTop: 40, marginBottom: 40 }}>
            TOWNS
          </SubHeading>
          <LetterList>
            {Object.entries(townAtoZ).map((item) => {
              const [key, value] = item;
              return (
                <Letter key={key} isActive={value}>
                  {value ? (
                    <Link href={`/site-map-towns/${key}`} prefetch={false}>
                      <Text fontSize={13}>{key}</Text>
                    </Link>
                  ) : (
                    <Text fontSize={13}>{key}</Text>
                  )}
                </Letter>
              );
            })}
          </LetterList>
        </PageWrapper>
      </Section>
    </>
  );
};

export default SiteMapGlobal;
